import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";

interface CheckboxItemProps {
  selected: boolean;
  text: string;
  onClickFunction: (event?: any) => void;
}

const CheckboxItem: React.FC<CheckboxItemProps> = ({
  selected,
  text,
  onClickFunction,
}) => {
  return (
    <div
      className="group self-stretch h-6 inline-flex justify-start items-center gap-2 cursor-pointer"
      onClick={onClickFunction}
    >
      {selected ? (
        <MdCheckBox className="w-6 h-6 fill-neutral-700 group-hover:fill-neutral-500" />
      ) : (
        <MdCheckBoxOutlineBlank className="w-6 h-6 fill-neutral-700 group-hover:fill-neutral-500" />
      )}
      <div className="flex-1 justify-center text-neutral-700 group-hover:text-neutral-500 text-sm font-semibold font-sans leading-none">
        {text}
      </div>
    </div>
  );
};

export default CheckboxItem;
